{
  "chart": "患者病历",
  "mrn": "MRN",
  "demographics": {
    "pageTitle": "基本信息",
    "loading": "正在加载患者基本信息...",
    "loadError": "加载患者基本信息失败。",
    "returnToDashboard": "返回工作台",
    "updatedSuccess": "患者基本信息已更新",
    "updateError": "更新患者基本信息失败",
    "sections": {
      "personalInformation": "个人信息",
      "identification": "证件信息",
      "contactInformation": "联系方式",
      "address": "地址",
      "languageAndPreferences": "语言与偏好",
      "specialFlags": "特殊标识",
      "recordInformation": "记录信息"
    },
    "fields": {
      "fullName": "姓名",
      "alternativeName": "别名",
      "preferredName": "常用名",
      "dateOfBirth": "出生日期",
      "birthTime": "出生时间",
      "age": "年龄",
      "legalGender": "法定性别",
      "genderIdentity": "性别认同",
      "sexAtBirth": "出生时性别",
      "race": "种族",
      "ethnicity": "民族",
      "nationality": "国籍",
      "mrn": "MRN",
      "nationalIdType": "证件类型",
      "nationalIdNumber": "证件号码",
      "passportNumber": "护照号码",
      "passportCountry": "护照签发国",
      "primaryPhone": "主要电话",
      "mobilePhone": "手机",
      "email": "电子邮箱",
      "preferredContactMethod": "首选联系方式",
      "addressLine1": "地址第一行",
      "addressLine2": "地址第二行",
      "city": "城市",
      "stateProvince": "省/州",
      "postalCode": "邮政编码",
      "country": "国家",
      "primaryLanguage": "主要语言",
      "secondaryLanguage": "次要语言",
      "interpreterRequired": "需要口译员",
      "vipStatus": "VIP 状态",
      "confidentialityLevel": "保密级别",
      "medicalTourist": "医疗旅游患者",
      "homeCountry": "原籍国",
      "status": "状态",
      "deceased": "已故",
      "created": "创建时间",
      "lastModified": "最后修改",
      "passportOnFile": "护照已存档",
      "organDonorStatus": "器官捐献状态"
    },
    "statusValues": {
      "active": "活跃",
      "inactive": "停用"
    },
    "deceasedSummary": "是（{{date}}）",
    "deceasedDateUnknown": "日期不详",
    "legalGender": {
      "label": "法定性别",
      "values": {
        "male": "男",
        "female": "女",
        "other": "其他",
        "unknown": "未知"
      },
      "selectPlaceholder": "请选择性别"
    },
    "sexAtBirth": {
      "label": "出生时性别",
      "values": {
        "female": "女",
        "male": "男",
        "other": "其他",
        "unknown": "未知"
      },
      "notRecorded": "未记录"
    },
    "preferredContactMethod": {
      "label": "首选联系方式",
      "values": {
        "phone": "电话",
        "mobile": "手机",
        "email": "电子邮箱",
        "sms": "短信"
      },
      "notSpecified": "未指定"
    },
    "validation": {
      "fullNameRequired": "姓名为必填项",
      "dateOfBirthRequired": "出生日期为必填项",
      "countryRequired": "国家为必填项",
      "primaryLanguageRequired": "主要语言为必填项",
      "invalidEmail": "电子邮箱无效",
      "nationalIdValidationFailed": "证件号码校验失败：{{error}}",
      "invalidBirthTime": "出生时间必须为 HH:MM 格式"
    },
    "organDonor": {
      "notRecorded": "未记录",
      "registered": "已登记捐献",
      "optedOut": "已声明退出",
      "notRegistered": "未登记",
      "unknown": "不详"
    }
  },
  "registration": {
    "title": "患者登记",
    "subtitle": "在系统中登记新患者",
    "submit": "登记患者",
    "submitting": "正在登记...",
    "checkingDuplicates": "正在检查重复记录...",
    "registerNew": "登记新患者",
    "registeredSuccess": "患者登记成功",
    "registerError": "患者登记失败",
    "validationNationalIdFailed": "证件号码校验失败：{{error}}",
    "sections": {
      "basicInformation": "基本信息",
      "identification": "证件信息",
      "contactInformation": "联系方式",
      "address": "地址",
      "languageAndCommunication": "语言与沟通",
      "additionalInformation": "其他信息"
    },
    "fields": {
      "facility": "登记机构"
    },
    "placeholders": {
      "fullName": "例如：Tan Wei Ming 或 李小明",
      "alternativeName": "如适用，请填写罗马字拼写",
      "preferredName": "患者希望被称呼的名字",
      "nationalIdNumberDefault": "请输入证件号码",
      "primaryPhone": "+65 9123 4567",
      "mobilePhone": "+65 8123 4567",
      "email": "patient@example.com",
      "facility": "请选择机构"
    },
    "helperText": {
      "fullName": "请按官方证件上的姓名填写",
      "facility": "为该患者办理登记的机构。该机构的员工将可以查看此病历。"
    },
    "flags": {
      "vipPatient": "VIP 患者",
      "medicalTourist": "医疗旅游患者"
    },
    "duplicate": {
      "title": "发现可能重复的患者",
      "body": "以下既有患者与所输入信息匹配：",
      "mrnLabel": "MRN",
      "dobLabel": "DOB",
      "idLabel": "证件号",
      "matchSummary": "匹配度：{{score}}%（{{reasons}}）",
      "useExisting": "使用既有记录",
      "createNew": "这是一位新患者",
      "restricted": {
        "title_one": "存在 {{count}} 条您无权查看的可能匹配记录",
        "title_other": "存在 {{count}} 条您无权查看的可能匹配记录",
        "body": "该患者可能在其他机构已有病历。创建新病历前请联系病案管理部门——因该记录不在您的权限范围内，详细信息不予显示。"
      },
      "overrideReasonLabel": "仍要登记的理由",
      "overrideReasonPlaceholder": "例如：已与患者确认并非同一人",
      "overrideReasonHelp": "该理由将记录在您的账户名下。为同一人重复建档会导致病历分散。",
      "registerAnyway": "仍要登记"
    }
  },
  "search": {
    "title": "患者检索",
    "subtitle": "检索并管理患者记录",
    "placeholder": "按患者姓名、MRN 或证件号检索...",
    "advancedFilters": "高级筛选",
    "filters": {
      "mrnPlaceholder": "例如：P0000000001",
      "fullNamePlaceholder": "患者姓名",
      "phonePlaceholder": "电话号码",
      "emailPlaceholder": "电子邮箱"
    },
    "filterLabels": {
      "mrn": "MRN",
      "fullName": "姓名",
      "dateOfBirth": "出生日期",
      "phone": "电话",
      "email": "电子邮箱",
      "country": "国家",
      "status": "状态",
      "vip": "VIP"
    },
    "vipFilter": {
      "all": "全部",
      "vipOnly": "仅 VIP",
      "nonVipOnly": "仅非 VIP"
    },
    "statusFilter": {
      "all": "全部",
      "active": "活跃",
      "inactive": "停用"
    },
    "countryFilter": {
      "all": "全部国家"
    },
    "clearFilters": "清除筛选",
    "dateOfBirthAria": "出生日期筛选",
    "columns": {
      "mrn": "MRN",
      "fullName": "姓名",
      "dob": "DOB",
      "gender": "性别",
      "phone": "电话",
      "country": "国家",
      "status": "状态"
    },
    "results": {
      "searching": "正在检索患者...",
      "loadError": "加载患者失败，请重试。",
      "retry": "重试",
      "empty": "未找到患者，请调整检索条件。",
      "showing": "显示第 {{from}} – {{to}} 条，共 {{total}} 位患者"
    }
  },
  "myPatients": {
    "title": "我的患者",
    "subtitle": "我负责的在院患者",
    "searchPlaceholder": "按姓名或MRN筛选...",
    "columns": {
      "mrn": "MRN",
      "patient": "姓名",
      "dob": "DOB",
      "sex": "性别",
      "class": "类别",
      "relationship": "关系",
      "admitted": "入院时间"
    },
    "kind": {
      "attending": "主治",
      "careTeam": "医疗团队",
      "referral": "转诊",
      "coverage": "覆盖"
    },
    "restrictedBadge": "受限",
    "empty": {
      "title": "您的患者面板为空",
      "body": "您主管、代管或会诊转入的患者将显示在这里。",
      "censusAction": "打开床位看板"
    },
    "results": {
      "searching": "正在加载您的患者...",
      "loadError": "加载您的患者失败，请重试。",
      "retry": "重试",
      "showing": "显示第 {{from}} – {{to}} 条，共 {{total}} 位患者"
    }
  },
  "encounters": {
    "title": "就诊记录",
    "create": "新建就诊",
    "filters": "筛选",
    "filterLabels": {
      "status": "状态",
      "class": "类别",
      "fromDate": "起始日期",
      "toDate": "截止日期"
    },
    "filterPlaceholders": {
      "allStatuses": "全部状态",
      "allClasses": "全部类别"
    },
    "clearFilters": "清除筛选",
    "fromDateAria": "起始日期",
    "toDateAria": "截止日期",
    "columns": {
      "encounterNumber": "就诊编号",
      "class": "类别",
      "status": "状态",
      "admitDate": "入院日期",
      "dischargeDate": "出院日期",
      "location": "科室位置",
      "chiefComplaint": "主诉"
    },
    "locationLabel": "位置 #{{id}}",
    "loading": "正在加载就诊记录...",
    "loadError": "加载就诊记录失败。",
    "empty": "该患者暂无就诊记录。",
    "showing": "显示第 {{from}} – {{to}} 条，共 {{total}} 条"
  },
  "identifiers": {
    "nationalIdType": {
      "label": "证件类型",
      "none": "无",
      "values": {
        "nric": "NRIC",
        "hkid": "HKID",
        "myKad": "MyKad",
        "aadhaar": "Aadhaar",
        "ktp": "KTP",
        "myNumber": "My Number",
        "thaiNationalId": "泰国国民身份证"
      },
      "country": {
        "nric": "新加坡",
        "hkid": "中国香港",
        "myKad": "马来西亚",
        "aadhaar": "印度",
        "ktp": "印度尼西亚",
        "myNumber": "日本",
        "thaiNationalId": "泰国"
      },
      "placeholderByType": {
        "nric": "例如：S1234567D",
        "myKad": "例如：850101-14-5678",
        "hkid": "例如：A123456(3)",
        "aadhaar": "例如：2341 2341 2346",
        "thaiNationalId": "例如：1-2345-45678-78-1"
      }
    },
    "nationalIdCheck": {
      "checksumMismatch": "该证件号码的校验字符不符。请核对病人身份证件上的号码。",
      "unavailable": "无法校验该证件号码。请核对病人身份证件上的号码。",
      "acknowledge": "我已核对身份证件上的号码",
      "acknowledgeRequired": "保存前请核对身份证件上的证件号码并确认。"
    }
  },
  "country": {
    "values": {
      "sg": "新加坡",
      "my": "马来西亚",
      "th": "泰国",
      "id": "印度尼西亚",
      "ph": "菲律宾",
      "vn": "越南",
      "hk": "中国香港",
      "tw": "中国台湾",
      "jp": "日本",
      "kr": "韩国",
      "cn": "中国",
      "in": "印度",
      "au": "澳大利亚",
      "nz": "新西兰"
    }
  },
  "language": {
    "values": {
      "en": "英语",
      "zh": "中文（普通话）",
      "ms": "马来语",
      "ta": "泰米尔语",
      "th": "泰语",
      "id": "印度尼西亚语",
      "vi": "越南语",
      "ja": "日语",
      "ko": "韩语",
      "hi": "印地语"
    }
  },
  "contact": {
    "addTitle": "添加联系人",
    "editTitle": "编辑联系人",
    "name": "姓名",
    "relationship": {
      "label": "关系",
      "selectPlaceholder": "请选择...",
      "values": {
        "spouse": "配偶",
        "parent": "父母",
        "child": "子女",
        "sibling": "兄弟姐妹",
        "guardian": "监护人",
        "friend": "朋友",
        "other": "其他"
      }
    },
    "phone": "电话",
    "email": "电子邮件",
    "emergencyContact": "紧急联系人",
    "validation": {
      "nameRequired": "联系人姓名为必填项",
      "relationshipRequired": "关系为必填项",
      "phoneRequired": "电话号码为必填项",
      "invalidEmail": "电子邮件格式无效"
    },
    "savedSuccess": "联系人添加成功",
    "saveError": "添加联系人失败"
  },
  "immunization": {
    "addTitle": "添加免疫接种记录",
    "vaccineName": "疫苗名称",
    "vaccineNamePlaceholder": "例如:流感、新冠 (Pfizer)、乙型肝炎",
    "vaccineCode": "疫苗代码 (CVX)",
    "vaccineCodePlaceholder": "例如:141",
    "administeredDate": "接种日期",
    "lotNumber": "批号",
    "lotNumberPlaceholder": "例如:AB1234",
    "site": {
      "label": "部位",
      "selectPlaceholder": "请选择部位",
      "values": {
        "leftDeltoid": "左三角肌",
        "rightDeltoid": "右三角肌",
        "leftThigh": "左大腿",
        "rightThigh": "右大腿",
        "leftGluteal": "左臀部",
        "rightGluteal": "右臀部",
        "other": "其他"
      }
    },
    "route": {
      "label": "途径",
      "selectPlaceholder": "请选择途径",
      "values": {
        "intramuscular": "肌肉注射 (IM)",
        "subcutaneous": "皮下注射 (SC)",
        "intradermal": "皮内注射 (ID)",
        "oral": "口服",
        "intranasal": "鼻腔喷雾"
      }
    },
    "doseAmount": "剂量",
    "doseAmountPlaceholder": "例如:0.5 mL",
    "administeredBy": "接种人员",
    "administeredByPlaceholder": "医务人员姓名或工号",
    "nextDueDate": "下次接种日期",
    "notes": "备注",
    "notesPlaceholder": "其他备注...",
    "validation": {
      "vaccineNameRequired": "疫苗名称为必填项",
      "administeredDateRequired": "接种日期为必填项"
    },
    "savedSuccess": "免疫接种记录已添加",
    "saveError": "添加免疫接种记录失败"
  },
  "insurance": {
    "addTitle": "添加保险方案",
    "submitLabel": "添加保险",
    "payerName": "支付方名称",
    "payerNamePlaceholder": "例如:友邦新加坡",
    "payerId": "支付方编号",
    "payerIdPlaceholder": "支付方标识",
    "planName": "方案名称",
    "planNamePlaceholder": "例如:HealthShield Gold Max",
    "planType": {
      "label": "方案类型",
      "selectPlaceholder": "请选择类型",
      "values": {
        "hmo": "HMO",
        "ppo": "PPO",
        "epo": "EPO",
        "pos": "POS",
        "government": "政府",
        "private": "私人",
        "corporate": "团体",
        "other": "其他"
      }
    },
    "memberId": "会员编号",
    "memberIdPlaceholder": "会员编号",
    "policyNumber": "保单号",
    "policyNumberPlaceholder": "输入保单号",
    "groupNumber": "团体编号",
    "groupNumberPlaceholder": "团体编号",
    "subscriberName": "投保人姓名",
    "subscriberNamePlaceholder": "如与患者不同请填写",
    "subscriberRelationship": {
      "label": "与投保人关系",
      "values": {
        "self": "本人",
        "spouse": "配偶",
        "child": "子女",
        "parent": "父母",
        "other": "其他"
      }
    },
    "priority": {
      "label": "优先级",
      "values": {
        "primary": "主要",
        "secondary": "次要",
        "tertiary": "第三方"
      }
    },
    "effectiveDate": "生效日期",
    "terminationDate": "终止日期",
    "copayAmount": "自付金额 ($)",
    "coinsurancePercent": "共付比例 (%)",
    "deductibleAmount": "免赔额 ($)",
    "outOfPocketMax": "自付上限 ($)",
    "preAuthRequired": "需事先授权",
    "notes": "备注",
    "notesPlaceholder": "其他备注...",
    "validation": {
      "payerNameRequired": "支付方名称为必填项",
      "planNameRequired": "方案名称为必填项",
      "memberIdRequired": "会员编号为必填项",
      "effectiveDateRequired": "生效日期为必填项"
    },
    "savedSuccess": "保险方案已添加",
    "saveError": "添加保险方案失败"
  },
  "problem": {
    "addTitle": "添加问题",
    "problemName": "问题名称",
    "problemNamePlaceholder": "例如:2 型糖尿病",
    "icdCode": "ICD-10 编码",
    "icdSearchPlaceholder": "搜索 ICD-10 编码或描述...",
    "onsetDate": "发病日期",
    "severity": {
      "label": "严重程度",
      "values": {
        "mild": "轻度",
        "moderate": "中度",
        "severe": "重度"
      }
    },
    "notes": "备注",
    "notesPlaceholder": "其他临床备注...",
    "validation": {
      "problemNameRequired": "问题名称为必填项"
    },
    "savedSuccess": "问题已添加至问题列表",
    "saveError": "添加问题失败"
  },
  "accounts": {
    "pageTitle": "患者账户",
    "backToDashboard": "仪表盘",
    "searchPatientLabel": "搜索患者",
    "searchPlaceholder": "按姓名或 MRN 搜索...",
    "searching": "搜索中...",
    "noPatientsFound": "未找到患者",
    "loadingAccount": "正在加载账户...",
    "mrnLabel": "MRN",
    "generateStatement": "生成对账单",
    "statementComingSoon": "对账单生成功能即将上线",
    "paymentPlan": "付款计划",
    "paymentPlanComingSoon": "付款计划设置即将上线",
    "totalCharges": "总费用",
    "totalPayments": "总付款",
    "adjustments": "调整",
    "outstandingBalance": "未付余额",
    "transactionHistory": "交易记录",
    "columns": {
      "date": "日期",
      "type": "类型",
      "description": "说明",
      "amount": "金额",
      "balance": "余额"
    },
    "transactionType": {
      "label": "类型",
      "values": {
        "charge": "收费",
        "payment": "付款",
        "adjustment": "调整"
      }
    },
    "loadingTransactions": "正在加载交易...",
    "noTransactionsFound": "未找到交易记录",
    "emptyState": "搜索患者以查看其账户"
  },
  "proxies": {
    "title": "授权代理人",
    "description": "经授权可访问此患者门户数据的看护人、监护人和法定代理人。已撤销的记录将保留用于审计。",
    "addProxy": "添加代理人",
    "newRelationshipHeading": "新建代理关系",
    "proxyUserId": "代理用户 ID",
    "proxyUserIdPlaceholder": "用户 ID(来自 管理 → 用户)",
    "proxyUserIdHelper": "在 管理 → 用户 中查找。用户选择组件将在后续版本中提供。",
    "relationship": {
      "label": "关系",
      "values": {
        "parent": "父母",
        "legalGuardian": "法定监护人",
        "spousePartner": "配偶 / 伴侣",
        "adultChild": "成年子女",
        "powerOfAttorney": "委托代理人",
        "healthcareAgent": "医疗代理人"
      }
    },
    "accessLevel": {
      "label": "访问权限",
      "values": {
        "full": "完全",
        "limited": "受限",
        "emergency": "紧急"
      },
      "descriptions": {
        "full": "全部门户数据 — 预约、检查结果、消息、表单。",
        "limited": "仅预约和消息(青少年常用)。",
        "emergency": "患者无法自理时医疗代理人享有的紧急访问权限。"
      }
    },
    "startDate": "开始日期",
    "endDate": "结束日期",
    "startDateAria": "生效开始日期",
    "endDateAria": "生效结束日期",
    "grantAccess": "授予代理访问权限",
    "userIdRequired": "需要代理用户 ID",
    "createdSuccess": "代理关系已创建",
    "duplicateError": "该用户已经是同种关系的代理人",
    "invalidDataError": "代理数据无效",
    "createError": "创建代理失败",
    "revokedSuccess": "已撤销代理访问权限",
    "revokeError": "撤销代理失败",
    "emptyState": "尚未配置代理人。请使用上方按钮授予看护人、监护人或医疗代理人访问权限。",
    "sections": {
      "active": "有效 ({{count}})",
      "plannedInactive": "计划中 / 未生效 ({{count}})",
      "revoked": "已撤销 ({{count}})"
    },
    "userIdFallback": "用户 #{{id}}",
    "noEndDate": "(无结束日期)",
    "revokedOn": "已撤销 {{date}}",
    "revokeTitle": "撤销代理访问权限",
    "confirmRevokeTitle": "撤销代理访问权限?",
    "confirmRevokeBody": "{{name}} 将立即失去对此患者门户数据的访问权限。该记录将保留在审计日志中。",
    "confirmRevokeLabel": "撤销访问"
  },
  "merge": {
    "title": "患者合并",
    "description": "合并重复的患者记录。源患者将被停用,所有临床数据将移至目标(保留)患者。",
    "sourceLabel": "源患者(将被停用)",
    "targetLabel": "目标患者(保留记录)",
    "clearSelection": "清除选择",
    "searchPlaceholder": "按姓名、MRN 或电话搜索...",
    "fields": {
      "mrn": "MRN",
      "dob": "出生日期",
      "gender": "性别",
      "country": "国家",
      "phone": "电话",
      "email": "电子邮件"
    },
    "counts": {
      "encounters": "就诊记录:{{count}}",
      "allergies": "过敏史:{{count}}",
      "problems": "问题:{{count}}"
    },
    "samePatientWarning": "源患者和目标患者必须不同。",
    "comparisonTitle": "人口学信息对比",
    "comparisonSubtitle": "差异以琥珀色高亮显示。",
    "columns": {
      "field": "字段",
      "source": "源 ({{mrn}})",
      "target": "目标 ({{mrn}})"
    },
    "comparisonLabels": {
      "fullName": "全名",
      "mrn": "MRN",
      "dateOfBirth": "出生日期",
      "gender": "性别",
      "phone": "电话",
      "email": "电子邮件",
      "country": "国家",
      "nationalId": "身份证号"
    },
    "reasonLabel": "合并原因",
    "reasonPlaceholder": "合并这些记录的原因(必填)",
    "notesLabel": "备注(可选)",
    "notesPlaceholder": "关于此次合并的其他备注",
    "mergeButton": "合并患者",
    "mergeSuccess": "患者合并成功",
    "mergeError": "合并患者失败",
    "successHeading": "合并已成功完成。",
    "successBodyPrefix": "患者 {{mrn}} 已被停用。所有临床数据已移至 ",
    "successBodySuffix": "。",
    "confirmTitle": "确认合并患者",
    "confirmBodyPrefix": "此操作",
    "confirmBodyEmphasis": "无法撤销",
    "confirmBodySuffix": "。患者 {{sourceMrn}} ({{sourceName}}) 将被停用,所有临床数据将移至患者 {{targetMrn}} ({{targetName}})。",
    "confirmButton": "确认合并患者",
    "swapSides": "Swap source and target",
    "preloadError": "Could not load the selected records.",
    "detailLoadError": "无法加载患者病历。"
  },
  "allergy": {
    "addTitle": "添加过敏史",
    "editTitle": "编辑过敏史",
    "allergen": "过敏原",
    "allergenPlaceholder": "例如：青霉素、花生",
    "type": "类型",
    "typeOptions": {
      "drug": "药物",
      "food": "食物",
      "environmental": "环境"
    },
    "severityLabel": "严重程度",
    "severity": {
      "mild": "轻度",
      "moderate": "中度",
      "severe": "重度",
      "lifeThreatening": "危及生命"
    },
    "reaction": "反应",
    "reactionPlaceholder": "例如：荨麻疹、过敏性休克、恶心",
    "reactionOptions": {
      "rash": "皮疹",
      "hives": "荨麻疹",
      "anaphylaxis": "过敏性休克",
      "swelling": "肿胀",
      "itching": "瘙痒",
      "other": "其他"
    },
    "onsetDate": "发生日期",
    "notes": "备注",
    "notesPlaceholder": "其他备注...",
    "verifiedBy": "核实人",
    "noKnownAllergies": "无已知过敏",
    "savedSuccess": "过敏史添加成功",
    "saveError": "添加过敏史失败",
    "deletedSuccess": "已删除过敏记录"
  },
  "components": {
    "allergyBadge": {
      "title": "{{name}} ({{type}}) - {{severity}}"
    },
    "bradenScale": {
      "title": "Braden 量表（压疮风险）",
      "footer": "总分范围：6-23。分数越低，发生压力性损伤的风险越高。",
      "scoreFormat": "得分：{{score}} — {{riskBand}}",
      "riskBand": {
        "veryHigh": "极高风险",
        "high": "高风险",
        "moderate": "中度风险",
        "mild": "轻度风险",
        "none": "无风险"
      },
      "subscales": {
        "sensoryPerception": {
          "label": "{{n}}. 感觉",
          "options": {
            "1": "{{n}} - 完全受限",
            "2": "{{n}} - 非常受限",
            "3": "{{n}} - 轻度受限",
            "4": "{{n}} - 未受损"
          }
        },
        "moisture": {
          "label": "{{n}}. 潮湿",
          "options": {
            "1": "{{n}} - 持续潮湿",
            "2": "{{n}} - 非常潮湿",
            "3": "{{n}} - 偶尔潮湿",
            "4": "{{n}} - 极少潮湿"
          }
        },
        "activity": {
          "label": "{{n}}. 活动",
          "options": {
            "1": "{{n}} - 卧床",
            "2": "{{n}} - 限于椅上",
            "3": "{{n}} - 偶尔行走",
            "4": "{{n}} - 经常行走"
          }
        },
        "mobility": {
          "label": "{{n}}. 移动能力",
          "options": {
            "1": "{{n}} - 完全不能移动",
            "2": "{{n}} - 非常受限",
            "3": "{{n}} - 轻度受限",
            "4": "{{n}} - 无限制"
          }
        },
        "nutrition": {
          "label": "{{n}}. 营养",
          "options": {
            "1": "{{n}} - 非常差",
            "2": "{{n}} - 可能不足",
            "3": "{{n}} - 充足",
            "4": "{{n}} - 优良"
          }
        },
        "frictionShear": {
          "label": "{{n}}. 摩擦与剪切力",
          "options": {
            "1": "{{n}} - 有问题",
            "2": "{{n}} - 可能有问题",
            "3": "{{n}} - 无明显问题"
          }
        }
      }
    },
    "morseFallScale": {
      "title": "莫尔斯跌倒量表",
      "scoreFormat": "评分：{{score}} — {{riskBand}}",
      "subscales": {
        "historyOfFalling": {
          "label": "{{n}}. 跌倒史",
          "options": {
            "0": "无（{{score}}）",
            "25": "有（{{score}}）"
          }
        },
        "secondaryDiagnosis": {
          "label": "{{n}}. 次要诊断",
          "options": {
            "0": "无（{{score}}）",
            "15": "有（{{score}}）"
          }
        },
        "ambulatoryAid": {
          "label": "{{n}}. 行走辅助",
          "options": {
            "0": "无／卧床休息／护士协助（{{score}}）",
            "15": "拐杖／手杖／助行器（{{score}}）",
            "30": "依靠家具支撑（{{score}}）"
          }
        },
        "ivHeparinLock": {
          "label": "{{n}}. 静脉输液／肝素锁",
          "options": {
            "0": "无（{{score}}）",
            "20": "有（{{score}}）"
          }
        },
        "gait": {
          "label": "{{n}}. 步态",
          "options": {
            "0": "正常／卧床休息／轮椅（{{score}}）",
            "10": "虚弱（{{score}}）",
            "20": "受损（{{score}}）"
          }
        },
        "mentalStatus": {
          "label": "{{n}}. 精神状态",
          "options": {
            "0": "能正确认识自身能力（{{score}}）",
            "15": "高估自身能力／忘记自身限制（{{score}}）"
          }
        }
      },
      "interventions": {
        "high": "高风险干预：实施标准跌倒预防措施。为患者佩戴跌倒风险腕带。在床边张贴跌倒风险标识。对患者及家属进行教育。保持床位处于最低位置并锁定刹车。确保呼叫铃在伸手可及范围内。穿防滑鞋。安排如厕时间表。必要时考虑1对1看护。",
        "moderate": "中风险干预：实施标准跌倒预防措施。为患者佩戴跌倒风险腕带。对患者及家属进行教育。保持床位处于最低位置并锁定刹车。确保呼叫铃在伸手可及范围内。穿防滑鞋。",
        "low": "低风险干预：提供良好的基础护理。教育患者安全活动。介绍环境和呼叫铃的使用方法。"
      }
    }
  },
  "banner": {
    "label": "患者信息",
    "vip": "VIP",
    "vipTitle": "VIP 患者",
    "mrn": "MRN",
    "dob": "DOB",
    "ageSuffix": "岁",
    "sex": "性别",
    "codeStatusAria": "抢救代码：{{status}}",
    "isolationAria": "隔离：{{status}}",
    "isolation": {
      "contact": "接触隔离",
      "droplet": "飞沫隔离",
      "airborne": "空气隔离",
      "none": "无"
    },
    "fallRiskAria": "跌倒风险：{{level}}",
    "fallRisk": {
      "label": "跌倒风险",
      "low": "低",
      "moderate": "中",
      "high": "高"
    },
    "pressureInjuryRisk": "压疮风险",
    "pressureInjuryRiskAria": "压疮风险：{{level}}",
    "interpreter": "口译员",
    "interpreterRequired": "需要口译员 — {{language}}",
    "languageNotSpecified": "未指定语言",
    "weightKg": "{{weight}} kg",
    "allergiesLabel": "过敏",
    "moreAllergies_one": "+还有 {{count}} 项",
    "moreAllergies_other": "+还有 {{count}} 项",
    "nkda": "NKDA",
    "allergiesUnknown": "过敏史未知——加载失败"
  },
  "chartFrame": {
    "navAriaLabel": "患者病历导航",
    "tabs": {
      "summary": "概览",
      "encounters": "就诊记录",
      "orders": "医嘱",
      "results": "检查结果",
      "medications": "用药",
      "notes": "病历记录",
      "problems": "问题列表",
      "allergies": "过敏史",
      "immunizations": "免疫接种",
      "intakeOutput": "出入量",
      "carePlans": "护理计划",
      "referrals": "转诊",
      "familyHistory": "家族史",
      "socialHistory": "社会史",
      "surgicalHistory": "手术史",
      "advanceDirectives": "预立医疗指示",
      "insurance": "保险",
      "contacts": "联系人",
      "proxies": "代理人",
      "identifiers": "标识号",
      "addresses": "地址",
      "consents": "Consents",
      "pregnancyStatus": "Pregnancy",
      "implantableDevices": "器械",
      "ccdaImports": "C-CDA 导入"
    },
    "groups": {
      "clinical": "临床",
      "history": "病史",
      "admin": "管理"
    },
    "breakGlass": {
      "auditBanner": "紧急访问 — 所有操作均在审计记录中。访问将在 15 分钟后过期。",
      "dialogTitle": "受限患者记录",
      "dialogSubtitle": "需要紧急访问授权",
      "dialogBody": "此患者记录已受限。您必须提供访问理由。所有紧急访问均会被记录和审计。",
      "justificationLabel": "访问理由",
      "justificationPlaceholder": "请输入访问此受限记录的临床理由...",
      "justificationRequired": "紧急访问需要提供理由。",
      "requestError": "申请紧急访问失败。请重试或联系管理员。",
      "submitButton": "访问记录",
      "submitting": "申请中...",
      "passwordLabel": "确认您的密码",
      "passwordPlaceholder": "请再次输入您的密码",
      "passwordRequired": "紧急访问需要您的密码。",
      "passwordIncorrect": "密码不正确，请重试。",
      "passwordHelp": "确认在此工作站操作的是您本人。",
      "totpLabel": "验证码",
      "totpPlaceholder": "6位验证码",
      "totpRequired": "紧急访问需要您的身份验证器验证码。",
      "totpIncorrect": "验证码不正确，请重试。",
      "totpHelp": "确认在此工作站操作的是您本人。",
      "totpEnrollHint": "尚未绑定身份验证器——请先在“我的资料”中绑定，以便使用紧急访问。"
    },
    "invalidId": {
      "title": "无效的患者 ID",
      "body": "提供的患者 ID 无效。",
      "action": "搜索患者"
    },
    "notFound": {
      "title": "未找到患者",
      "body": "无法加载患者数据。患者可能不存在或您没有访问权限。",
      "action": "搜索患者"
    },
    "loadError": {
      "title": "患者图表加载失败",
      "body": "图表无法加载。请重试。",
      "action": "重试"
    }
  },
  "address": {
    "title": "地址",
    "addAddress": "新增地址",
    "newTitle": "新增地址",
    "editTitle": "编辑地址",
    "loading": "正在加载地址...",
    "loadError": "加载地址信息失败。",
    "empty": "尚无地址记录。",
    "addressType": {
      "label": "类型",
      "values": {
        "home": "家庭",
        "work": "工作单位",
        "temporary": "临时",
        "billing": "账单"
      }
    },
    "fields": {
      "addressLine1": "地址第一行",
      "addressLine2": "地址第二行",
      "addressLine3": "地址第三行",
      "district": "区/县",
      "city": "城市",
      "stateProvince": "省/州",
      "postalCode": "邮政编码",
      "country": "国家/地区"
    },
    "placeholders": {
      "addressLine1": "街道地址",
      "addressLine2": "公寓、单元、楼层",
      "addressLine3": "建筑、街区",
      "district": "区/乡镇",
      "postalCode": "例如:123456",
      "country": "例如:SG"
    },
    "primaryBadge": "主要",
    "setPrimary": "设为主要地址",
    "primaryHelper": "(其他地址将被取消主要标记)",
    "fromLabel": "起始:{{date}}",
    "toLabel": "结束:{{date}}",
    "save": "保存",
    "update": "更新",
    "cancel": "取消",
    "editTooltip": "编辑地址",
    "removeTooltip": "删除地址",
    "addedSuccess": "已新增地址",
    "addError": "新增地址失败",
    "updatedSuccess": "地址已更新",
    "updateError": "更新地址失败",
    "removedSuccess": "地址已删除",
    "removeError": "删除地址失败",
    "requiredError": "地址第一行和国家为必填项",
    "confirmRemoveTitle": "删除地址",
    "confirmRemoveMessage": "确定要删除此{{type}}地址吗?",
    "confirmRemoveLabel": "删除"
  },
  "allergies": {
    "pageTitle": "过敏史",
    "addAllergy": "新增过敏",
    "loading": "正在加载过敏记录...",
    "loadError": "加载过敏信息失败。",
    "nka": {
      "title": "无已知过敏 (NKA)",
      "body": "本患者无过敏记录。"
    },
    "sections": {
      "active": "活动期过敏 ({{count}})",
      "inactive": "已停用过敏 ({{count}})"
    },
    "fields": {
      "reaction": "反应",
      "severity": "严重程度",
      "onset": "起病时间",
      "recorded": "记录时间"
    },
    "inactiveSummary": "反应:{{reaction}} | 严重程度:{{severity}}",
    "deactivate": "停用",
    "deactivateTooltip": "停用过敏记录",
    "deleteTooltip": "删除过敏记录",
    "deactivatedSuccess": "过敏记录已停用",
    "deactivateError": "停用过敏记录失败",
    "removedSuccess": "过敏记录已删除",
    "removeError": "删除过敏记录失败",
    "confirmDeactivateTitle": "确认停用",
    "confirmDeactivateMessage": "确定要停用\"{{name}}\"吗?",
    "confirmDeleteTitle": "确认删除",
    "confirmDeleteMessage": "确定要永久删除\"{{name}}\"吗?",
    "confirmLabel": "确认"
  },
  "problems": {
    "pageTitle": "问题列表",
    "addProblem": "新增问题",
    "loading": "正在加载问题列表...",
    "loadError": "加载问题列表失败。",
    "tabs": {
      "active": "活动期 ({{count}})",
      "resolvedInactive": "已解决/已停用 ({{count}})"
    },
    "sortByLabel": "排序方式:",
    "sortBy": {
      "onsetDate": "起病日期",
      "severity": "严重程度"
    },
    "status": {
      "label": "状态",
      "values": {
        "active": "活动期",
        "resolved": "已解决",
        "inactive": "已停用"
      }
    },
    "empty": {
      "active": "暂无活动期问题记录。",
      "resolved": "暂无已解决或已停用问题。"
    },
    "fields": {
      "onset": "起病",
      "resolved": "解决"
    },
    "resolveButton": "标记为已解决",
    "reactivateButton": "重新激活",
    "resolveTooltip": "标记为已解决",
    "reactivateTooltip": "重新激活",
    "statusUpdatedSuccess": "问题状态已更新",
    "statusUpdateError": "更新问题状态失败"
  },
  "immunizations": {
    "pageTitle": "免疫接种",
    "addImmunization": "新增免疫接种",
    "loading": "正在加载免疫接种记录...",
    "loadError": "加载免疫接种记录失败。",
    "empty": "未找到免疫接种记录。",
    "dueOverdue": "应接种/逾期免疫 ({{count}})",
    "upcoming": "即将接种 ({{count}})",
    "dueLabel": "应接种:{{date}}",
    "fromDateLabel": "起始日期",
    "toDateLabel": "结束日期",
    "fromDateAria": "免疫接种起始日期",
    "toDateAria": "免疫接种结束日期",
    "clearFilters": "清除",
    "cvxLabel": "CVX:{{code}}",
    "columns": {
      "vaccine": "疫苗",
      "date": "接种日期",
      "lotNumber": "批号",
      "site": "部位",
      "administeredBy": "接种者",
      "nextDue": "下次接种",
      "status": "状态"
    },
    "dueStatus": {
      "label": "状态",
      "values": {
        "overdue": "逾期",
        "dueToday": "今日到期",
        "upcoming": "即将到期"
      }
    }
  },
  "contacts": {
    "pageTitle": "联系人",
    "addContact": "新增联系人",
    "loading": "正在加载联系人...",
    "loadError": "加载联系人信息失败。",
    "empty": "尚无联系人记录。",
    "emergencyBadge": "紧急",
    "sections": {
      "emergency": "紧急联系人 ({{count}})",
      "other": "其他联系人 ({{count}})"
    },
    "editTooltip": "编辑联系人",
    "deleteTooltip": "删除联系人",
    "deletedSuccess": "联系人已删除",
    "deleteError": "删除联系人失败",
    "confirmDeleteTitle": "删除联系人",
    "confirmDeleteMessage": "确定要删除\"{{name}}\"吗?",
    "confirmDeleteLabel": "删除"
  },
  "insurances": {
    "pageTitle": "保险",
    "addInsurance": "新增保险",
    "loading": "正在加载保险信息...",
    "loadError": "加载保险信息失败。",
    "empty": {
      "title": "无保险计划",
      "body": "本患者尚无保险计划记录。"
    },
    "sections": {
      "active": "有效计划 ({{count}})",
      "inactive": "已失效计划 ({{count}})"
    },
    "status": {
      "label": "状态",
      "values": {
        "active": "有效",
        "inactive": "失效",
        "pendingVerification": "待核验"
      }
    },
    "fields": {
      "memberId": "会员号",
      "groupNumber": "团体号",
      "effectiveDate": "生效日期",
      "terminationDate": "终止日期",
      "copay": "自付",
      "coinsurance": "共保",
      "deductible": "免赔额",
      "subscriber": "投保人"
    },
    "preAuthBadge": "需事前授权",
    "lastVerifiedLabel": "最近核验:{{date}}",
    "copayAmount": "${{amount}}",
    "coinsurancePercent": "{{percent}}%",
    "deductibleAmount": "${{amount}}",
    "verifyButton": "核验",
    "verifyTooltip": "核验资格",
    "editButton": "编辑",
    "verifySuccess": "已发起资格核验",
    "verifyError": "资格核验失败"
  },
  "identifiersTab": {
    "pageTitle": "标识号",
    "addIdentifier": "新增标识号",
    "loading": "正在加载标识号...",
    "loadError": "加载标识号信息失败。",
    "empty": "尚无标识号记录。",
    "newTitle": "新增标识号",
    "type": {
      "label": "类型",
      "selectPlaceholder": "请选择类型...",
      "values": {
        "externalMrn": "外部 MRN",
        "insuranceId": "保险编号",
        "studyId": "研究编号",
        "healthCard": "健康卡",
        "nationalRegistry": "国家登记号",
        "passport": "护照",
        "driverLicense": "驾驶证",
        "other": "其他"
      }
    },
    "fields": {
      "value": "号码",
      "assigningAuthority": "签发机构",
      "effectiveDate": "生效日期",
      "expiryDate": "到期日期"
    },
    "placeholders": {
      "value": "例如:S1234567D",
      "assigningAuthority": "例如:新加坡 MOH"
    },
    "status": {
      "label": "状态",
      "values": {
        "active": "有效",
        "inactive": "失效"
      }
    },
    "columns": {
      "type": "类型",
      "value": "号码",
      "assigningAuthority": "签发机构",
      "effectiveDate": "生效日期",
      "expiryDate": "到期日期",
      "status": "状态",
      "actions": "操作"
    },
    "save": "保存",
    "cancel": "取消",
    "removeTooltip": "删除标识号",
    "addedSuccess": "标识号已新增",
    "addError": "新增标识号失败",
    "removedSuccess": "标识号已删除",
    "removeError": "删除标识号失败",
    "requiredError": "类型和号码为必填项",
    "confirmRemoveTitle": "删除标识号",
    "confirmRemoveMessage": "确定要删除\"{{type}}:{{value}}\"吗?",
    "confirmRemoveLabel": "删除"
  },
  "pages": {
    "advanceDirectives": {
      "title": "预先医疗指示",
      "addButton": "添加指示",
      "emptyState": "该患者尚未记录任何预先医疗指示。",
      "loading": "正在加载预先医疗指示...",
      "loadError": "加载预先医疗指示失败。",
      "documentLink": "查看文件",
      "effectivePrefix": "生效:",
      "reviewPrefix": "复审:",
      "form": {
        "title": "新建预先医疗指示",
        "labels": {
          "directiveType": "指示类型",
          "status": "状态",
          "effectiveDate": "生效日期",
          "notes": "备注",
          "optional": "选填"
        },
        "placeholders": {
          "notes": "关于该指示的补充备注..."
        },
        "selectTypePlaceholder": "请选择类型...",
        "aria": {
          "effectiveDate": "生效日期"
        },
        "buttons": {
          "save": "保存指示",
          "cancel": "取消"
        }
      },
      "directiveType": {
        "DNR": "不施行心肺复苏(DNR)",
        "living-will": "生前预嘱",
        "POLST": "POLST / MOLST",
        "healthcare-proxy": "医疗代理人",
        "power-of-attorney": "持久代理授权"
      },
      "directiveStatus": {
        "active": "有效",
        "inactive": "无效",
        "revoked": "已撤销",
        "pending": "待复审"
      },
      "toast": {
        "added": "预先医疗指示已添加",
        "addFailed": "添加预先医疗指示失败",
        "directiveTypeRequired": "指示类型为必填项"
      }
    },
    "familyHistory": {
      "title": "家族史",
      "addButton": "添加条目",
      "emptyState": "该患者尚未记录任何家族史。",
      "loading": "正在加载家族史...",
      "loadError": "加载家族史失败。",
      "onsetAge": "发病年龄:{{age}} 岁",
      "outcomePrefix": "结局:",
      "form": {
        "title": "新建家族史条目",
        "labels": {
          "relationship": "亲属关系",
          "conditionName": "疾病名称",
          "conditionCode": "疾病代码",
          "onsetAge": "发病年龄",
          "outcome": "结局",
          "optional": "选填"
        },
        "placeholders": {
          "onsetAge": "年龄(岁)"
        },
        "selectRelationshipPlaceholder": "请选择亲属关系...",
        "selectOutcomePlaceholder": "请选择结局...",
        "buttons": {
          "save": "保存条目",
          "cancel": "取消"
        }
      },
      "relationship": {
        "Mother": "母亲",
        "Father": "父亲",
        "Sibling": "兄弟姐妹",
        "Maternal Grandmother": "外祖母",
        "Maternal Grandfather": "外祖父",
        "Paternal Grandmother": "祖母",
        "Paternal Grandfather": "祖父",
        "Child": "子女",
        "Aunt": "姑母/姨母",
        "Uncle": "伯父/叔父/舅父"
      },
      "outcome": {
        "alive": "存活",
        "deceased": "已故",
        "unknown": "未知"
      },
      "toast": {
        "added": "家族史条目已添加",
        "addFailed": "添加家族史条目失败",
        "relationshipAndConditionRequired": "亲属关系和疾病名称为必填项"
      }
    },
    "socialHistory": {
      "title": "社会史",
      "editButton": "编辑",
      "loading": "正在加载社会史...",
      "loadError": "加载社会史失败。",
      "labels": {
        "smokingStatus": "吸烟状况",
        "alcoholUse": "饮酒",
        "substanceUse": "药物使用",
        "housing": "居住情况",
        "employment": "就业状况",
        "safetyScreening": "安全筛查",
        "notes": "备注"
      },
      "placeholders": {
        "notes": "附加备注..."
      },
      "buttons": {
        "save": "保存更改",
        "cancel": "取消"
      },
      "toast": {
        "updated": "社会史已更新",
        "updateFailed": "社会史更新失败"
      },
      "smokingStatus": {
        "never": "从不吸烟者",
        "former": "既往吸烟者",
        "currentDaily": "当前每日吸烟者",
        "currentOccasional": "当前偶尔吸烟者",
        "unknown": "不明"
      },
      "alcoholUse": {
        "None": "无",
        "Social/Occasional": "社交/偶尔",
        "Moderate": "中等",
        "Heavy": "大量",
        "In Recovery": "康复中",
        "Unknown": "不明"
      },
      "substanceUse": {
        "None": "无",
        "Current Use": "当前使用",
        "Former Use": "既往使用",
        "In Treatment": "治疗中",
        "Unknown": "不明"
      },
      "housing": {
        "Stable": "稳定",
        "Unstable": "不稳定",
        "Homeless": "无家可归",
        "Assisted Living": "辅助生活",
        "Nursing Facility": "护理机构",
        "Unknown": "不明"
      },
      "employment": {
        "Employed Full-Time": "全职就业",
        "Employed Part-Time": "兼职就业",
        "Self-Employed": "自雇",
        "Unemployed": "失业",
        "Retired": "退休",
        "Student": "学生",
        "Disabled": "残障无法工作",
        "Unknown": "不明"
      },
      "safetyScreening": {
        "No Concerns": "无顾虑",
        "Concerns Identified": "已识别顾虑",
        "Declined to Answer": "拒绝回答",
        "Not Screened": "未筛查"
      }
    },
    "surgicalHistory": {
      "title": "手术史",
      "addButton": "添加手术",
      "emptyState": "此患者无手术史记录。",
      "loading": "正在加载手术史...",
      "loadError": "无法加载手术史。",
      "cptLabel": "CPT {{code}}",
      "dateLabel": "日期: {{date}}",
      "surgeonLabel": "外科医生: {{name}}",
      "anesthesiaLabel": "麻醉: {{type}}",
      "outcomePrefix": "结果:",
      "complicationsPrefix": "并发症:",
      "form": {
        "title": "新增手术史记录",
        "labels": {
          "procedureName": "手术名称",
          "procedureCode": "手术代码",
          "procedureCodeSuffix": "(CPT)",
          "date": "日期",
          "surgeonName": "外科医生姓名",
          "anesthesiaType": "麻醉类型",
          "laterality": "侧别",
          "outcome": "结果",
          "complications": "并发症"
        },
        "placeholders": {
          "surgeonName": "外科医生姓名",
          "complications": "如有并发症..."
        },
        "selectPlaceholder": "请选择...",
        "aria": {
          "procedureDate": "手术日期"
        },
        "buttons": {
          "save": "保存记录",
          "cancel": "取消"
        }
      },
      "anesthesiaType": {
        "general": "全身麻醉",
        "regional": "区域麻醉",
        "local": "局部麻醉",
        "spinal": "脊髓麻醉",
        "epidural": "硬膜外麻醉",
        "sedation": "镇静",
        "none": "无",
        "unknown": "不明"
      },
      "laterality": {
        "left": "左侧",
        "right": "右侧",
        "bilateral": "双侧"
      },
      "toast": {
        "added": "已添加手术史记录",
        "addFailed": "添加手术史记录失败",
        "procedureNameRequired": "必须填写手术名称"
      }
    },
    "referralManagement": {
      "title": "转诊",
      "addButton": "新建转诊",
      "refresh": "刷新",
      "loading": "正在加载转诊...",
      "errorState": "加载转诊失败。",
      "emptyState": "此患者尚无转诊记录。",
      "emptyStateFiltered": "没有符合所选状态的转诊。",
      "ariaFilterStatus": "按状态筛选转诊",
      "externalBadge": "外部",
      "filterStatus": {
        "allLabel": "全部状态"
      },
      "table": {
        "type": "类型",
        "reason": "原因",
        "specialty": "专科",
        "priority": "优先级",
        "status": "状态",
        "requested": "申请日期",
        "target": "目标日期"
      },
      "form": {
        "title": "新建转诊",
        "labels": {
          "referralType": "转诊类型",
          "priority": "优先级",
          "specialty": "专科",
          "reason": "原因",
          "targetDate": "目标日期",
          "clinicalNotes": "临床备注",
          "optional": "选填"
        },
        "placeholders": {
          "reason": "转诊原因",
          "clinicalNotes": "补充临床备注..."
        },
        "selectReferralTypePlaceholder": "请选择类型...",
        "selectSpecialtyPlaceholder": "请选择专科...",
        "buttons": {
          "create": "创建转诊",
          "cancel": "取消"
        }
      },
      "referralType": {
        "consultation": "会诊",
        "transfer": "转交诊治",
        "second-opinion": "第二意见",
        "diagnostic": "诊断性",
        "therapeutic": "治疗性"
      },
      "priority": {
        "routine": "常规",
        "urgent": "紧急",
        "stat": "STAT"
      },
      "status": {
        "draft": "草稿",
        "submitted": "已提交",
        "accepted": "已接受",
        "scheduled": "已排期",
        "completed": "已完成",
        "cancelled": "已取消"
      },
      "toasts": {
        "createSuccess": "转诊已创建",
        "createFailed": "创建转诊失败",
        "validationFailed": "转诊类型和原因为必填项"
      }
    }
  },
  "consents": {
    "title": "Consents",
    "grant": "Grant consent",
    "revoke": "Revoke",
    "confirmRevoke": "Revoke this consent? This records a revocation event and cannot be undone.",
    "loading": "Loading consents…",
    "loadError": "Failed to load consents.",
    "empty": "No consent records for this patient.",
    "table": {
      "scope": "Scope",
      "category": "Category",
      "decision": "Decision",
      "status": "Status",
      "effective": "Effective",
      "recorded": "Recorded",
      "actions": "Actions",
      "history": "Event history"
    },
    "toast": {
      "revoked": "Consent revoked.",
      "revokeFailed": "Failed to revoke consent."
    },
    "scope": {
      "patientPrivacy": "Patient privacy",
      "research": "Research",
      "treatment": "Treatment",
      "adr": "Adverse drug reaction"
    },
    "decision": {
      "permit": "Permit",
      "deny": "Deny"
    },
    "status": {
      "draft": "Draft",
      "proposed": "Proposed",
      "active": "Active",
      "rejected": "Rejected",
      "inactive": "Inactive",
      "enteredInError": "Entered in error"
    },
    "eventType": {
      "granted": "Granted",
      "revoked": "Revoked",
      "evaluated": "Evaluated",
      "accessGranted": "Access granted",
      "accessDenied": "Access denied"
    },
    "events": {
      "loading": "Loading history…",
      "empty": "No events recorded."
    },
    "form": {
      "title": "Grant consent",
      "submit": "Grant consent",
      "savedSuccess": "Consent recorded.",
      "saveError": "Failed to record consent."
    },
    "fields": {
      "scope": "Scope",
      "decision": "Decision",
      "category": "Category",
      "categoryPlaceholder": "e.g. medical-records, imaging",
      "performer": "Performer",
      "performerPlaceholder": "e.g. Patient/123 or Practitioner/45",
      "purpose": "Purpose",
      "dataClass": "Data class",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "notes": "Notes"
    }
  },
  "pregnancy": {
    "title": "Pregnancy & Lactation Screening",
    "currentHeading": "Current status",
    "recordHeading": "Record a status",
    "historyHeading": "History",
    "pregnancyLabel": "Pregnancy",
    "lactationLabel": "Lactation",
    "eddLabel": "Estimated due date",
    "sourceLabel": "Source",
    "notesLabel": "Notes",
    "recordButton": "Record status",
    "recordedOn": "Recorded {{date}}",
    "eddOn": "Estimated due date {{date}}",
    "outOfDate": "Out of date",
    "neverAsked": "Never asked",
    "notRecorded": "Not recorded",
    "noHistory": "No screening has been recorded for this patient.",
    "savedSuccess": "Screening status recorded",
    "saveError": "Could not record the screening status",
    "status": {
      "pregnant": "Pregnant",
      "notPregnant": "Not pregnant",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "lactationStatus": {
      "lactating": "Lactating",
      "notLactating": "Not lactating",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "source": {
      "patientReported": "Patient reported",
      "clinician": "Clinician",
      "lab": "Laboratory"
    },
    "columns": {
      "recordedAt": "Recorded",
      "pregnancy": "Pregnancy",
      "lactation": "Lactation",
      "edd": "Due date",
      "source": "Source",
      "notes": "Notes"
    },
    "errors": {
      "notesTooLong": "Notes must be 1000 characters or fewer",
      "eddOnlyWhenPregnant": "An estimated due date applies only to a pregnant status"
    }
  },
  "nursingAssessment": {
    "title": "Nursing Assessment",
    "subtitle": "The Morse and Braden scores recorded here update this patient's risk badges.",
    "assessmentType": "Assessment type",
    "type": {
      "admission": "Admission",
      "shift": "Shift",
      "focused": "Focused",
      "discharge": "Discharge"
    },
    "levelOfConsciousness": "Level of consciousness",
    "loc": {
      "alert": "Alert",
      "drowsy": "Drowsy",
      "lethargic": "Lethargic",
      "confused": "Confused",
      "unresponsive": "Unresponsive"
    },
    "mobilityLevel": "Mobility",
    "mobility": {
      "independent": "Independent",
      "assistiveDevice": "Assistive device",
      "assistOfOne": "Assist of one",
      "assistOfTwo": "Assist of two",
      "bedbound": "Bedbound"
    },
    "fallRiskFactors": "Fall risk factors",
    "fallRiskFactorsPlaceholder": "e.g. unsteady gait, IV pole, sedation",
    "pressureInjuryPresent": "Pressure injury already present",
    "painAssessment": "Pain assessment",
    "painPlaceholder": "Site, character, score, intervention",
    "generalNotes": "General notes",
    "save": "Save assessment",
    "saving": "Saving…",
    "saved": "Assessment recorded",
    "saveFailed": "Could not record the assessment",
    "notClinical": "Your account has no clinical identity, so it cannot sign a nursing assessment.",
    "history": "Previous assessments",
    "historyEmpty": "No assessments recorded for this encounter yet.",
    "bands": "Fall: {{fall}} · Pressure: {{pressure}}",
    "notScored": "not scored"
  },
  "duplicates": {
    "title": "Duplicate Review",
    "subtitle": "Candidate duplicate records found by the matching scanner. Review each pair and merge, or record that they are different people.",
    "noPermission": "You do not have permission to review duplicate patient records.",
    "loading": "Loading candidates...",
    "loadFailed": "Could not load the duplicate worklist.",
    "empty": "No candidates to review.",
    "dismissed": "Decision recorded.",
    "dismissFailed": "Could not record the decision.",
    "prev": "Previous",
    "next": "Next",
    "pageOf": "Page {{page}} of {{totalPages}}",
    "columns": {
      "score": "Score",
      "patients": "Records",
      "matchedOn": "Matched on",
      "detected": "Detected",
      "actions": "Actions"
    },
    "filters": {
      "status": "Review status",
      "minScore": "Min score"
    },
    "status": {
      "pending": "Pending",
      "reviewed": "Reviewed",
      "merged": "Merged",
      "not_duplicate": "Not a duplicate",
      "ignored": "Ignored"
    },
    "confidence": {
      "very_high": "Very high",
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "matchedField": {
      "nameMatch": "Name",
      "dobMatch": "Date of birth",
      "genderMatch": "Gender",
      "nationalIdMatch": "National ID",
      "phoneMatch": "Phone",
      "addressMatch": "Address"
    },
    "actions": {
      "review": "Review",
      "dismiss": "Not a duplicate"
    },
    "dismissDialog": {
      "title": "Record a review decision",
      "body": "{{name1}} ({{mrn1}}) and {{name2}} ({{mrn2}}) will be removed from the worklist.",
      "reasonHelp": {
        "not_duplicate": "These are different people. The pair will not return unless the matching evidence materially improves.",
        "ignored": "Do not action this pair for now. Same suppression rule applies."
      },
      "notesPlaceholder": "Notes (optional)",
      "cancel": "Cancel",
      "confirm": "Record decision"
    },
    "restricted": {
      "title_one": "有 {{count}} 组配对涉及您无权查看的患者",
      "title_other": "有 {{count}} 组配对涉及您无权查看的患者",
      "body": "您的某位患者可能与其他机构的病历重复。因判断该配对需查看您权限外的患者，故未在列表中显示——请联系病案管理部门审核。"
    }
  },
  "__review_duplicateReview": "Duplicate-review worklist copy — ships English pending market sign-off; 'merge' vs 'link' is a records-management register that differs by market.",
  "recordExport": {
    "button": "导出病历",
    "exporting": "正在导出…",
    "success": "病历已导出",
    "failed": "导出失败 — 未下载任何内容",
    "tooltip": "将该患者的完整病历下载为可携带文件"
  },
  "device": {
    "addTitle": "记录植入器械",
    "editTitle": "记录取出",
    "deviceName": "器械名称",
    "deviceNamePlaceholder": "例如：Evera MRI ICD、药物洗脱支架",
    "deviceNameTooLong": "器械名称不得超过512个字符",
    "deviceType": "器械类型",
    "deviceTypePlaceholder": "例如：起搏器、支架、假体",
    "udi": "UDI",
    "udiPlaceholder": "医疗器械唯一标识载体",
    "deviceCode": "器械编码",
    "deviceCodeSystem": "编码体系",
    "deviceCodeSystemPlaceholder": "例如：GMDN、SNOMED CT",
    "manufacturer": "制造商",
    "modelNumber": "型号",
    "lotNumber": "批号",
    "serialNumber": "序列号",
    "implantDate": "植入日期",
    "explantDate": "取出日期",
    "status": "状态",
    "statusOptions": {
      "active": "在用",
      "inactive": "停用",
      "explanted": "已取出"
    },
    "mriSafety": "MRI安全性",
    "mriSafetyOptions": {
      "safe": "安全",
      "conditional": "有条件安全",
      "unsafe": "不安全",
      "unknown": "未知"
    },
    "notes": "备注",
    "notesPlaceholder": "其他备注...",
    "savedSuccess": "器械记录成功",
    "saveError": "记录器械失败",
    "updatedSuccess": "取出记录成功",
    "updateError": "记录取出失败",
    "explantRequiresDate": "已取出的器械需要取出日期",
    "explantBeforeImplant": "取出日期不能早于植入日期"
  },
  "devices": {
    "pageTitle": "植入器械",
    "addDevice": "记录器械",
    "loading": "正在加载器械...",
    "loadError": "加载器械信息失败。",
    "empty": {
      "title": "无植入器械",
      "body": "该患者尚未记录任何器械。"
    },
    "sections": {
      "active": "在用器械 ({{count}})",
      "history": "已取出/停用 ({{count}})"
    },
    "fields": {
      "udi": "UDI",
      "manufacturer": "制造商",
      "implanted": "植入",
      "explanted": "取出",
      "mriSafety": "MRI安全性",
      "recorded": "记录于"
    },
    "recordExplant": "记录取出",
    "explantTooltip": "记录取出该器械",
    "removeTooltip": "删除条目",
    "removedSuccess": "器械条目已删除",
    "removeError": "删除器械条目失败",
    "confirmDeleteTitle": "确认删除",
    "confirmDeleteMessage": "从列表中删除“{{name}}”？仅删除误录的条目——记录从体内取出请使用“记录取出”。",
    "confirmLabel": "确认"
  },
  "ccdaImports": {
    "title": "C-CDA 导入",
    "subtitle": "待核对的接收文档。打开导入，逐条审核并入病历。",
    "empty": "该患者暂无导入文档。",
    "loadError": "无法加载导入。",
    "received": "接收",
    "docType": "类型",
    "status": "状态",
    "pending": "待处理",
    "entries": "条目",
    "match": "匹配",
    "mismatch": "ID 不匹配",
    "statuses": {
      "pending": "待处理",
      "reviewed": "已审核",
      "dismissed": "已忽略"
    },
    "docTypes": {
      "ccd": "CCD",
      "referral-note": "转诊单",
      "discharge-summary": "出院小结",
      "other": "其他"
    }
  },
  "ccdaReview": {
    "title": "导入 #{{id}}",
    "back": "返回导入列表",
    "loadError": "无法加载此导入。",
    "mismatchWarning": "发送方标识与该患者不匹配。接受前请确认文档归属。",
    "unnamed": "未命名条目",
    "accept": "接受",
    "reject": "拒绝",
    "accepted": "条目已并入病历",
    "rejected": "条目已拒绝",
    "alreadyReviewed": "已被他人审核 — 下方已刷新",
    "reviewError": "审核失败",
    "confirmAcceptTitle": "接受并入病历?",
    "confirmAcceptMessage": "“{{name}}”将被添加到该患者病历中。",
    "confirmRejectTitle": "拒绝此条目?",
    "confirmRejectMessage": "“{{name}}”将从队列中移除。原始文档保留存档。",
    "sections": {
      "problem": "问题",
      "medication": "用药",
      "allergy": "过敏"
    },
    "statuses": {
      "accepted": "已接受",
      "rejected": "已拒绝"
    }
  }
}
